import axios, { AxiosResponse } from 'axios';

const routeName = `/events`;
export async function getEvents(): Promise<any> {
    const filter = {
        "include": [
            { "relation": "eventCategory" },
            { "relation": "site" }
        ],
        "order": [
            "date DESC"
          ]
      };
    return axios.get(process.env.VUE_APP_CJ_API_URL + routeName+'?filter='+JSON.stringify(filter))
        .then(resp => {
            return {data: resp.data};
        })
        .catch(err => {
            console.log('error getEvents !',err);
            return {error : err};
        });
}

export async function getEvent(id: number): Promise<any> {
    const filter = {
        "include": [
            { "relation": "eventCategory" },
            { "relation": "site" }
        ]
      };
    return axios.get(process.env.VUE_APP_CJ_API_URL + routeName+'/'+id+'?filter='+JSON.stringify(filter))
        .then(resp => {
            return {data: resp.data};
        })
        .catch(err => {
            console.log('error getEvent !',err);
            return {error : err};
        });
}

export async function getEventsWithGuestCategoryCounters(): Promise<any> {
    return axios.get(process.env.VUE_APP_CJ_API_URL + routeName+'/counters')
        .then(resp => {
            return {data: resp.data};
        })
        .catch(err => {
            console.log('error getEvents !',err);
            return {error : err};
        });
}

export async function getEventWithGuestCategoryCounters(id: number): Promise<any> {
    return axios.get(process.env.VUE_APP_CJ_API_URL + routeName+'/'+id+'/counters?')
        .then(resp => {
            return {data: resp.data};
        })
        .catch(err => {
            console.log('error getEvent !',err);
            return {error : err};
        });
}

export async function getEventGuestCategoryQuestions(id: number): Promise<any> {
    const filter = {
        "include": [
            { "relation": "questions" }
        ]
      };
    return axios.get(process.env.VUE_APP_CJ_API_URL + routeName+'/'+id+'/guest-categories?filter='+JSON.stringify(filter))
        .then(resp => {
            return {data: resp.data};
        })
        .catch(err => {
            console.log('error getEventGuestCategoryQuestions !',err);
            return {error : err};
        });
}

export async function postEvent(data: object): Promise<any> {
    return axios.post(process.env.VUE_APP_CJ_API_URL + routeName,data)
        .then(resp => {
            
            return {data: resp.data};
        })
        .catch(err => {
            console.log('error postEvent !',err);
            return {error : err};
        });
}

export async function patchEvent(data: any): Promise<any> {
    if (data.dateString) delete data.dateString;
    if (data.subscriptionOpenLabel) delete data.subscriptionOpenLabel;
    if (data.site) delete data.site;
    if (data.eventCategory) delete data.eventCategory;
    if (data.updatedAt) delete data.updatedAt;
    if (data.createdAt) delete data.createdAt;
    return axios.patch(process.env.VUE_APP_CJ_API_URL + routeName+'/'+data.id,data)
        .then(resp => {
            return {data: 'success'};
        })
        .catch(err => {
            console.log('error patchEvent !',err);
            return {error : err};
        });
}

export async function deleteEvents(dataToDelete: any[]): Promise<any> {
    const successData: any[] = [];
    const errorData: any[]= [];
    for (const prop in dataToDelete) {
        const data = dataToDelete[prop];

        await axios.delete(process.env.VUE_APP_CJ_API_URL +routeName+'/'+data.id+'/withsubscriptiondata')
            .then(resp => {
                successData.push(data);
            })
            .catch(err => {
                errorData.push(data);
                console.log('error deleteEvents',err);
            });
        }
    return {data: {successData: successData },
            error: {errorData: errorData}};
}

export async function getEventCategories(): Promise<any> {
    return axios.get(process.env.VUE_APP_CJ_API_URL + '/event-categories')
        .then(resp => {
            return {data: resp.data};
        })
        .catch(err => {
            console.log('error getEventCategories !',err);
            return {error : err};
        });
}

export async function getEventGuestCategories(eventId: number): Promise<any> {
    return axios.get(process.env.VUE_APP_CJ_API_URL + routeName+'/'+eventId+'/guest-categories')
        .then(resp => {
            return {data: resp.data};
        })
        .catch(err => {
            console.log('error getEventGuestCategories !',err);
            return {error : err};
        });
}

export async function postEventGuestCategoryRelations(data: object[]): Promise<any> {
    const successData: any[] = [];
    const errorData: any[]= [];
    
    for (const d of data){
        await axios.post(process.env.VUE_APP_CJ_API_URL + '/event-guest-category-relations',d)
        .then(resp => {
            successData.push(resp.data);
        })
        .catch(err => {
            console.log('error postEventGuestCategoryRelations !',err);
            errorData.push(err);
        });
    }

        return {data: {successData: successData },
            error: {errorData: errorData}};
}

export async function deleteEventGuestCategoryRelations(data: object[]): Promise<any> {
    const successData: any[] = [];
    const errorData: any[]= [];

    const idsToDelete: any[] = [];
    for (const d of data){
        const filter = {where: {
            eventId: d.eventId,
            guestCategoryId: d.guestCategoryId
        }};
        await axios.get(process.env.VUE_APP_CJ_API_URL + '/event-guest-category-relations?filter='+JSON.stringify(filter))
        .then(resp => {
            idsToDelete.push(resp.data[0]);
        })
        .catch(err => {
            console.log('error deleteEventGuestCategoryRelations !',err);
            errorData.push(err);
        });
    }

    for (const d of idsToDelete){
        await axios.delete(process.env.VUE_APP_CJ_API_URL + '/event-guest-category-relations/'+d.id)
        .then(resp => {
            successData.push(resp.data);
        })
        .catch(err => {
            console.log('error deleteEventGuestCategoryRelations !',err);
            errorData.push(err);
        });
    }

        return {data: {successData: successData },
            error: {errorData: errorData}};
}